import {useEffect, useState} from 'react'
import Chart from 'react-apexcharts'
import {colors} from '../../../utils/colors'
import DateHelper from '../../../utils/date'

const CHART_HEIGHT = 150
const CONTAINER_PADDING = 30

const LogsBarChart = ({logs, logsContainerRef, isDarkMode}) => {
    const [containerWidth, setContainerWidth] = useState(0)

    const groupedLogCounts = new Map()

    logs.forEach(({timestamp}) => {
        groupedLogCounts.set(
            timestamp,
            (groupedLogCounts.get(timestamp) || 0) + 1
        )
    })

    const chartData = Array.from(groupedLogCounts.entries())
        .sort(([a], [b]) => a - b)
        .map(([timestamp, count]) => ({
            x: timestamp,
            y: count
        }))

    const chartOptions = {
        chart: {
            type: 'bar',
            stacked: false,
            zoom: {enabled: true},
            toolbar: {
                show: true,
                export: {
                    csv: {
                        filename: 'logs_export',
                        headerCategory: 'Checked at',
                        dateFormatter(timestamp) {
                            return DateHelper.convertTimeStampToHour(new Date(timestamp))
                        }
                    }
                }
            }
        },
        grid: {
            show: true,
            borderColor: isDarkMode ? colors.colorMuted : colors.colorLightGrey,
            strokeDashArray: 4,
            yaxis: {lines: {show: true}},
            xaxis: {lines: {show: false}}
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: `${chartData.length}px`,
                borderRadius: 2
            }
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            type: 'datetime',
            style: {
                color: isDarkMode ? colors.colorMuted : colors.colorLightGrey
            },
            axisBorder: {
                color: isDarkMode ? colors.colorMuted : colors.colorLightGrey
            },
            labels: {
                rotate: -45,
                trim: true,
                style: {fontSize: '11px', colors: isDarkMode ? colors.colorFilterTitle : colors.colorPrimary}

            },
            tickPlacement: 'on'
        },
        yaxis: {
            labels: {
                style: {
                    colors: isDarkMode ? colors.colorFilterTitle : colors.colorPrimary,
                    fontSize: '11px'
                }
            }
        },
        tooltip: {
            style: {
                backgroundColor: isDarkMode ? colors.colorFilterTitle : colors.colorPrimary
            },
            x: {
                show: true,
                format: 'yyyy-MM-dd HH:mm'
            }
        }
    }

    const series = [
        {
            name: 'Log Count',
            data: chartData
        }
    ]

    useEffect(() => {
        const observer = new ResizeObserver(entries => {
            for (const entry of entries) {
                setContainerWidth(entry.contentRect.width)
            }
        })

        const containerEl = logsContainerRef?.current
        if (containerEl) {
            observer.observe(containerEl)
        }

        return () => observer.disconnect()
    }, [logsContainerRef])

    return (
        <Chart
            options={chartOptions}
            series={series}
            type="bar"
            height={CHART_HEIGHT}
            width={containerWidth - CONTAINER_PADDING}
        />
    )
}

export default LogsBarChart
